import { render, staticRenderFns } from "./arrowDown.vue?vue&type=template&id=55429b68&"
import script from "./arrowDown.vue?vue&type=script&lang=js&"
export * from "./arrowDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports